// Specific project colors (override hash-based colors)
export const PROJECT_COLOR_MAP: Record<string, string> = {
  'Buyr': '#C76C4F',
  'buyr': '#C76C4F',
  'Webb': '#ef4444',
  'webb': '#ef4444',
  'Plantr': '#22c55e',
  'plantr': '#22c55e',
}

// Fallback color palette for projects without specific colors
export const PROJECT_COLORS = [
  '#f97316', // orange
  '#22c55e', // green
  '#3b82f6', // blue
  '#a855f7', // purple
  '#ec4899', // pink
  '#14b8a6', // teal
  '#eab308', // yellow
  '#ef4444', // red
  '#6366f1', // indigo
  '#06b6d4', // cyan
]

// Get project color - uses specific mapping first, falls back to hash
export function getProjectColor(projectName: string): string {
  // Check for specific color mapping first
  if (PROJECT_COLOR_MAP[projectName]) {
    return PROJECT_COLOR_MAP[projectName]
  }

  // Fall back to hash-based color
  let hash = 0
  for (let i = 0; i < projectName.length; i++) {
    hash = projectName.charCodeAt(i) + ((hash << 5) - hash)
  }
  return PROJECT_COLORS[Math.abs(hash) % PROJECT_COLORS.length]
}
